import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import update from 'react-addons-update'
import { FormattedMessage, injectIntl } from 'react-intl'
import { SelectInput } from '../Inputs/Inputs'
import {
  CapitalButton,
} from '../Navigation/Buttons'

import styles from '../../../../css/devicePage.module.css'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

function PreferenceLanguage ({ user, backToUser, intl }) {
  const goBackOnceRef = useRef(false)

  const getInitialLanguage = () => {
    const {
      data: {
        locale,
      },
    } = user
    let {
      language = 'en',
    } = locale

    if (language !== 'es' && language !== 'en' && language !== 'fr') {
      if (
        'language' in navigator &&
        (navigator.language).substring(0, 2) === 'en'
      ) {
        language = 'en'
      } else if (
        'language' in navigator &&
        (navigator.language).substring(0, 2) === 'es'
      ) {
        language = 'es'
      } else if (
        'language' in navigator &&
        (navigator.language).substring(0, 2) === 'fr'
      ) {
        language = 'fr'
      } else {
        language = 'en'
      }
    }
    return {
      language,
      ...locale,
    }
  }

  const [state, setState] = useState({
    locale: getInitialLanguage(),
    invalid: false,
  })

  useEffect(() => {
    if (
      user.saved === true &&
      goBackOnceRef.current === false
    ) {
      goBackOnceRef.current = true
      setTimeout(() => {
        backToUser()
      }, 200)
    }
  }, [user.saved, backToUser])

  useEffect(() => () => {
    AppDispatcher.dispatch({
      action: 'unload-user-change',
    })
  }, [])

  const saveButtonFunction = () => {
    appDispatch()
  }

  const appDispatch = () => {
    AppDispatcher.dispatch({
      action: 'update-user',
      userID: user.id,
      change: {
        locale: state.locale,
      },
    })
  }

  const childChange = (event) => {
    handleChange(event.target.name, event.target.value)
  }

  const handleChange = (field, value, callback) => {
    const newState = update(
      state,
      {
        locale: {
          [field]: { $set: value },
        },
        invalid: { $set: false },
      }
    )
    setState(newState)
    if (callback) callback()
  }

  const {
    formatMessage,
  } = intl

  const options = {
    language: [
      {
        value: 'en',
        name: formatMessage({
          id: 'profile.language.english',
          defaultMessage: 'English',
          description: '',
        }),
      },
      {
        value: 'es',
        name: formatMessage({
          id: 'profile.language.spanish',
          defaultMessage: 'Español',
          description: '',
        }),
      },
      {
        value: 'fr',
        name: formatMessage({
          id: 'profile.language.french',
          defaultMessage: 'French',
          description: '',
        }),
      },
    ],
  }

  let saveButtonStyle = `${styles.saveButton} saveButton`
  if (state.invalid) {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonHidden}`
  } else if (user.saved === true) {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonSuccess}`
  } else if (user.saved === 'error') {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonError}`
  }

  return (
    <div>
      <section className={`${styles.simpleLink} ${styles.simpleLinkBorderPhysical}`}>
        <h5>
          <FormattedMessage
            id='profile.language.name'
            defaultMessage='Language'
            description='Language'
          />
        </h5>
        <div className={styles.simpleLinkValueEdit}>
          <SelectInput
            value={state.locale.language || 'en'}
            field='language'
            childChange={childChange}
            options={options.language}
            style={styles.settingSelectInput}
          />
        </div>
      </section>
      <section>
        <FormattedMessage
          id='setting.save'
          defaultMessage='SAVE'
          description='SAVE label'
        >
          {(txt) => (
            <CapitalButton
              text={txt}
              buttonFunction={saveButtonFunction}
              hSize='h2'
              style={saveButtonStyle}
            />
          )}
        </FormattedMessage>

      </section>
    </div>
  )
}

PreferenceLanguage.propTypes = {
  user: PropTypes.object.isRequired,
  backToUser: PropTypes.func.isRequired,
  intl: {
    formatMessage: PropTypes.func,
  },
}

export default injectIntl(PreferenceLanguage)
